import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const wbApi = axios.create({ baseURL: `${BACKEND_URL}/api/wb`, timeout: 30000 });
wbApi.interceptors.request.use((config) => {
  const t = localStorage.getItem('customer_token');
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const wbWsUrl = () => {
  const t = localStorage.getItem('customer_token');
  return `${BACKEND_URL.replace(/^http/, 'ws')}/api/wb/ws${t ? `?token=${encodeURIComponent(t)}` : ''}`;
};

export const fmt = (n) => Number(n || 0).toLocaleString('pt-BR');

/* Datas sempre no horário do Brasil. Se vier sem fuso (Mongo/UTC naive), trata como UTC. */
const TZ = 'America/Sao_Paulo';
const parseIso = (iso) => {
  if (iso instanceof Date) return iso;
  const s = String(iso || '');
  const d = new Date(/[zZ]$|[+-]\d{2}:?\d{2}$/.test(s) ? s : `${s}Z`);
  return Number.isNaN(d.getTime()) ? null : d;
};
export const horaBr = (iso) => { const d = parseIso(iso); return d ? d.toLocaleTimeString('pt-BR', { timeZone: TZ, hour: '2-digit', minute: '2-digit' }) : ''; };
export const dataHoraBr = (iso) => { const d = parseIso(iso); return d ? d.toLocaleString('pt-BR', { timeZone: TZ, day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : ''; };

export const fmtShort = (n) => {
  n = Number(n || 0);
  if (n >= 1_000_000) return (n / 1_000_000).toLocaleString('pt-BR', { maximumFractionDigits: 1 }) + 'M';
  if (n >= 10_000) return Math.floor(n / 1000).toLocaleString('pt-BR') + 'K';
  return n.toLocaleString('pt-BR');
};

export const countdown = (s) => {
  s = Math.max(0, Math.floor(Number(s || 0)));
  const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600),
    m = Math.floor((s % 3600) / 60), sec = s % 60;
  const p = (x) => String(x).padStart(2, '0');
  return d > 0 ? `${d}d ${p(h)}h ${p(m)}m ${p(sec)}s` : `${p(h)}:${p(m)}:${p(sec)}`;
};

export const candyImg = (kind) => `/wb/candy_${kind}.webp`;

export const REASONS = {
  event_not_live: 'O evento não está no ar agora.',
  insufficient_witch_coins: 'Moedas da Bruxa insuficientes. Recarregue para ganhar mais!',
  prize_pool_unavailable: 'O prêmio acabou de sair para outro jogador — suas moedas foram devolvidas.',
  missing_request_id: 'Tente de novo.',
};

export const wbError = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (d?.reason && REASONS[d.reason]) return REASONS[d.reason];
  return e?.message || 'Algo deu errado. Tente de novo.';
};
